import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=229702ac&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229702ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229702ac')) {
      api.createRecord('229702ac', component.options)
    } else {
      api.reload('229702ac', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=229702ac&scoped=true&", function () {
      api.rerender('229702ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y614QLCoIRte/JS/comp/SearchFilterTokens.vue"
export default component.exports